var Chaplin, SearchPopupView, View, template, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

template = require('views/templates/search-popup');

View = require('views/base/view');

Chaplin = require('chaplin');

module.exports = SearchPopupView = (function(_super) {
  __extends(SearchPopupView, _super);

  function SearchPopupView() {
    _ref = SearchPopupView.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  SearchPopupView.prototype.template = template;

  SearchPopupView.prototype.className = 'popup';

  SearchPopupView.prototype.tagName = 'div';

  SearchPopupView.prototype.id = 'search-popup';

  SearchPopupView.prototype.autoRender = true;

  SearchPopupView.prototype.container = 'body';

  SearchPopupView.prototype.listen = {
    'catalogue:search:complete mediator': 'searchComplete'
  };

  SearchPopupView.prototype.events = {
    'click .btn-close': 'closePopup',
    'click .page-list li': 'goToPage'
  };

  SearchPopupView.prototype.closePopup = function() {
    this.dispose();
    return false;
  };

  SearchPopupView.prototype.goToPage = function(e) {
    var page;
    page = $(e.currentTarget).attr('data-page');
    this.publishEvent('catalogue:goToPage', parseInt(page));
    this.closePopup();
    return false;
  };

  SearchPopupView.prototype.searchComplete = function(result) {
    this.model = new Chaplin.Model(result);
    return this.render();
  };

  return SearchPopupView;

})(View);
